import { Component, OnInit, NgZone } from "@angular/core";
import {
  ActionSheetController,
  AlertController,
  IonicModule,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
  ToastController,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { AnotacaoAddPage } from "../../anotacao-list/anotacao-add/anotacao-add.page";
import { CultoListaPresencaEncarregadosPage } from "../culto-lista-presenca-encarregados/culto-lista-presenca-encarregados.page";
import { CultoListaPresencaPage } from "../culto-lista-presenca/culto-lista-presenca.page";
import { EncontroProgramacaoPage } from "../../evento/encontro-programacao/encontro-programacao.page";
import { EscalaPage } from "../escala/escala.page";
import { CultoProvider } from "src/app/services/culto/culto";
import { UserProvider } from "src/app/services/user/user";
import { Browser } from "@capacitor/browser";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Barcode, BarcodeScanner, LensFacing } from "@capacitor-mlkit/barcode-scanning";
import { SemRegistroComponent } from "src/app/components/sem-registro/sem-registro";
import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { ImagePipe } from "src/app/pipes/image/image";
import { NomenclaturaPipe } from "src/app/pipes/nomenclatura/nomenclatura";
import { SafeHtmlPipe } from "src/app/pipes/safe-html/safe-html";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";
import { BarcodeScanningModalComponent } from "src/app/components/barcode-scanning/barcode-scanning";
import { InstituicaoProvider } from "src/app/services/instituicao/instituicao";
import { PessoaProvider } from "src/app/services/pessoa/pessoa";
import { Clipboard } from "@capacitor/clipboard";

declare var instituicaoConstants: { IS_CATHOLIC: any; IS_PWA: any };
@Component({
  selector: "app-culto-detalhes",
  templateUrl: "./culto-detalhes.page.html",
  styleUrls: ["./culto-detalhes.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    SafeHtmlPipe,
    ImagePipe,
    SemRegistroComponent,
    NomenclaturaPipe,
    LoadingSpinnerComponent,
  ],
})
export class CultoDetalhesPage implements OnInit {
  idCulto: string = "";
  dataInicio: string = "";
  isAdmEscala = false;
  idCultoAgenda: string = "";
  cultoAgenda: any = {
    culto: { eventoTipo: {} },
    encarregados: [],
    minhaFuncaoCulto: { pessoaFuncaoEspec: {} },
    pessoaPregador: {},
  };
  loaded: boolean = false;
  openModal: boolean = true;
  filtro: any = { q: "" };
  pagination: any = { currentPage: 0, pageCount: 0 };
  encarregadoList: any = [];
  public isCatholic = instituicaoConstants.IS_CATHOLIC;
  public isPWA = instituicaoConstants.IS_PWA;
  hasCheckIn = false;
  multiplosCheckin = false;
  isResponsavelCheckin = false;
  pessoaCheckin: any;
  isInstituicaoAtual: boolean;
  temEncarregados = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingController: LoadingController,
    public modalCtrl: ModalController,
    public cultoProvider: CultoProvider,
    public actionSheetCtrl: ActionSheetController,
    private alertCtrl: AlertController,
    public userProvider: UserProvider,
    private translate: TranslateService,
    private toastCtrl: ToastController,
    private readonly ngZone: NgZone,
    public pessoaProvider: PessoaProvider,
    public instituicao: InstituicaoProvider
  ) {
    this.idCulto = this.navParams.get("idCulto");
    this.dataInicio = this.navParams.get("dataInicio");
    this.idCultoAgenda = this.navParams.get("idCultoAgenda");
    this.openModal = this.navParams.get("modal") !== false;
    this.isInstituicaoAtual =
      this.navParams.get("isInstituicaoAtual") == this.userProvider.idInstituicao ||
      !this.navParams.get("isInstituicaoAtual")
        ? true
        : false;

    if (this.idCultoAgenda) {
      this.loadEncarregados(null);
    }

    this.buscar();
    setTimeout(() => {
      this.loaded = true;
    }, 1000);
  }

  ngOnInit() {}

  buscar() {
    this.cultoProvider.getCultoAgenda(this.idCulto, this.dataInicio, this.idCultoAgenda).subscribe((data) => {
      this.cultoAgenda = data;
      this.isResponsavelCheckin = data.permissaoLeituraQrCode;
      this.hasCheckIn = data.check;
      this.isAdmEscala = data.isAdmEscala;
      this.loaded = true;
    });
  }

  public closeModal() {
    this.modalCtrl.dismiss(this.idCultoAgenda);
  }

  confirmar(minhaFuncaoCulto: { id: any }, presenca: string) {
    let data = { id: minhaFuncaoCulto.id, presenca: presenca };
    this.cultoProvider.confirmarPresenca(data).subscribe((data) => {
      this.loadEncarregados(null);
      this.cultoProvider.getCultoAgenda(this.idCulto, this.dataInicio, this.idCultoAgenda).subscribe((data) => {
        this.cultoAgenda = data;
      });
    });
  }

  async selecionarCulto() {
    let data = {
      idCulto: this.idCulto,
      id: this.idCultoAgenda,
      dataInicio: this.dataInicio,
    };
    const modalPage = await this.modalCtrl.create({
      component: CultoListaPresencaPage,
      componentProps: data,
    });
    modalPage.present();

    (await modalPage.onWillDismiss()).data;
    if (data) {
      this.idCultoAgenda = data.id;
    }
  }

  async encarregados() {
    let data = {
      idCulto: this.idCulto,
      id: this.idCultoAgenda,
      dataInicio: this.dataInicio,
    };
    const modalPage = await this.modalCtrl.create({
      component: CultoListaPresencaEncarregadosPage,
      componentProps: data,
    });

    modalPage.present();

    (await modalPage.onWillDismiss()).data;
    if (data) {
      this.loadEncarregados(null);
      this.buscar();
    }
  }

  async anotacao() {
    let data = { idEntidade: this.idCultoAgenda, entidade: "cultoagenda" };
    const modalPage = await this.modalCtrl.create({
      component: AnotacaoAddPage,
      componentProps: data,
    });
    modalPage.present();
  }

  async detalhesProgramacao(p: any) {
    let data = { programacao: p };
    const modalPage = await this.modalCtrl.create({
      component: EncontroProgramacaoPage,
      componentProps: data,
    });
    modalPage.present();

    (await modalPage.onWillDismiss()).data;
    if (data) {
      this.idCultoAgenda = data.programacao;
    }
  }

  loadEncarregados(infiniteScroll: any) {
    this.pagination.currentPage++;
    this.cultoProvider.getEncarregados(this.filtro, this.pagination, this.idCultoAgenda).subscribe((res) => {
      if (!infiniteScroll) {
        this.encarregadoList = [];
      }
      
      if (res.pagination.totalCount !== "0") {
        this.temEncarregados = true;
      }

      this.encarregadoList = this.encarregadoList.concat(res.encarregados);
      this.pagination = res.pagination;

      if (infiniteScroll) infiniteScroll.target.complete();
    });
  }

  onCancel() {
    this.loadEncarregados(null);
    this.pagination = { currentPage: 0, pageCount: 0 };
  }

  onInput() {
    this.loadEncarregados(null);
  }

  async openEscala() {
    let data = {
      entidade: "cultoagenda",
      idEntidade: this.idCultoAgenda,
      idEscala: this.cultoAgenda.agenda.idEscala != "0" ? this.cultoAgenda.agenda.idEscala : null,
      tipo: "culto",
    };
    const modalPage = await this.modalCtrl.create({
      component: EscalaPage,
      componentProps: data,
    });
    modalPage.present();

    (await modalPage.onWillDismiss()).data;
    if (data) {
      this.loadEncarregados(null);
      this.cultoProvider.getCultoAgenda(this.idCulto, this.dataInicio, this.idCultoAgenda).subscribe((data) => {
        this.cultoAgenda = data;
      });
    }
  }

  public async openLink(link: { target: string; url: any }) {
    if (link.target == "_blank" && !this.isPWA) {
      await Browser.open({ url: link.url });
    } else {
      await Browser.open({ url: link.url });
    }
  }

  async remover(pessoa: { pessoa: { nome: string } }) {
    let alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant("Confirma Exclusão?"),
      message: this.translate.instant("Excluir") + " " + pessoa.pessoa.nome,
      buttons: [
        {
          text: this.translate.instant("Não"),
          handler: () => {},
        },
        {
          text: this.translate.instant("Sim"),
          // pessoa.removido = '1';
          handler: () => {
            this.cultoProvider.removerPessoa(pessoa).subscribe((data) => {
              this.encarregadoList.splice(this.encarregadoList.indexOf(pessoa), 1);
            });
          },
        },
      ],
    });
    alert.present();
  }

  async detalhes(encarregado: any) {
    if (this.userProvider.isAdmEscala()) {
      let actionSheet = await this.actionSheetCtrl.create({
        header: this.translate.instant("Opções"),
        buttons: [
          {
            text: this.translate.instant("Remover"),
            handler: () => {
              this.remover(encarregado);
            },
          },
          {
            text: this.translate.instant("Leitura QR Code"),
            handler: () => {
              this.configuracao(encarregado);
            },
          },
        ],
      });

      await actionSheet.present();
    }
  }

  async configuracao(encarregado: any) {
    (
      await this.alertCtrl.create({
        cssClass: "alerta-personalizado",
        mode: "ios",
        header: this.translate.instant("Habilitar configuração?"),
        message: this.translate.instant("Pode ler QR Code de participantes para dar presença?"),
        buttons: [
          {
            text: this.translate.instant("Desabilitar"),
            handler: () => {
              this.salvarPermissaoLeituraQrCode(encarregado.id);
            },
          },
          {
            text: this.translate.instant("Habilitar"),
            handler: () => {
              this.salvarPermissaoLeituraQrCode(encarregado.id, true);
            },
          },
        ],
      })
    ).present();
  }

  salvarPermissaoLeituraQrCode(idEscalaFuncaoPessoa: any, permissaoLeituraQrcode = false) {
    this.cultoProvider.salvarPermissaoLeituraQrCode(idEscalaFuncaoPessoa, permissaoLeituraQrcode).subscribe((data) => {
      if (data) {
        this.loadEncarregados(null);
        this.successToast();
      } else {
        this.errorToast();
      }
    });
  }

  async successToast() {
    const toast = await this.toastCtrl.create({
      message: this.translate.instant("Configuração salva com sucesso"),
      duration: 2000,
    });

    toast.present();
  }

  async errorToast() {
    const toast = await this.toastCtrl.create({
      message: this.translate.instant("Erro ao salvar configuração"),
      duration: 2000,
    });

    toast.present();
  }

  async copiar() {
    const valor = this.extractContent(this.cultoAgenda.agenda.pauta || "");
    await Clipboard.write({
      string: valor,
    });

    const toast = await this.toastCtrl.create({
      message: this.translate.instant("Copiado com sucesso"),
      duration: 3000,
    });
    await toast.present();
  }

  extractContent(s: string) {
    var span = document.createElement("span");
    span.innerHTML = s;
    return span.textContent || span.innerText;
  }

  async checkPermission() {
    BarcodeScanner.checkPermissions().then((result) => {
      if (result.camera != "granted") {
        return;
      }
    });

    BarcodeScanner.removeAllListeners().then(() => {
      BarcodeScanner.addListener("googleBarcodeScannerModuleInstallProgress", (event) => {
        this.ngZone.run(() => {
          const { state, progress } = event;
        });
      });
    });
  }

  leitor() {
    this.iniciarScanner(this.multiplosCheckin);
  }

  async iniciarScanner(multiplosCheckin: boolean) {
    try {
      await this.checkPermission();
      const formats = LensFacing.Back || [];
      const lensFacing = LensFacing.Back;

      const element = await this.modalCtrl.create({
        component: BarcodeScanningModalComponent,
        cssClass: "barcode-scanning-modal",
        showBackdrop: false,
        componentProps: {
          formats: formats,
          lensFacing: lensFacing,
        },
      });
      element.present();

      element.onDidDismiss().then(async (result: any) => {
        const barcode: Barcode = result.data?.barcode;

        if (await this.validaPermissaoPresenca(barcode?.displayValue)) {
          this.presenca();

          if (multiplosCheckin) {
            this.reiniciarScanner(multiplosCheckin);
          }
        } else {
          BarcodeScanner.stopScan();

          if (this.multiplosCheckin) {
            this.showAlert("Atenção", "Para continuar, clique no ícone do QR Code");
          } else if (result.data?.barcode) {
            this.showAlert();
          }
        }
      });
    } catch (err) {
      this.showAlert("Atenção", "Não foi possível abrir a câmera do celular. Valide as permissões do aplicativo");
    }
  }

  reiniciarScanner(check: boolean) {
    setTimeout(() => {
      this.iniciarScanner(check);
    }, 1000);
  }

  async validaPermissaoPresenca(textBarCode: any): Promise<boolean> {
    const parsedBarCode = this.parseBarCode(textBarCode);
    let wasReadedQrCodePerson = this.checkIfQrCodePersonWasRead(parsedBarCode);

    if (!wasReadedQrCodePerson && parsedBarCode && !this.hasCheckIn && parsedBarCode != this.idCulto) {
      const isPerson = await this.verifyIfIsPerson(parsedBarCode.C);
      if (isPerson) {
        this.pessoaCheckin = {
          idPessoa: parsedBarCode.C,
        };

        wasReadedQrCodePerson = true;
      }
    }

    if (this.isInstituicaoAtual) {
      if (this.shouldNotValidate(wasReadedQrCodePerson)) {
        // this.showAlert();
        return false;
      }
    }

    if (this.isResponsavelCheckin && !this.hasCheckIn) {
      await this.handleCheckinResponsibility(parsedBarCode);
    }

    if (!this.isBarCodeValid(textBarCode, wasReadedQrCodePerson)) {
      this.showAlert();
      return false;
    }

    return true;
  }

  private async verifyIfIsPerson(parsedBarCode: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.pessoaProvider.verifyIfIsPerson(parsedBarCode).subscribe(
        (data: any) => {
          resolve(data);
        },
        (error: any) => {
          reject(error);
        }
      );
    });
  }

  parseBarCode(textBarCode: any): any {
    try {
      return JSON.parse(textBarCode);
    } catch (error) {
      return {};
    }
  }

  checkIfQrCodePersonWasRead(parsedBarCode: any): boolean {
    return typeof parsedBarCode === "object" && "C" in parsedBarCode && "N" in parsedBarCode && "I" in parsedBarCode;
  }

  shouldNotValidate(wasReadedQrCodePerson: boolean): boolean {
    const hasAutoCheckinAndReadedQrCodePerson = this.hasCheckIn && wasReadedQrCodePerson;
    const isResponsibleCheckinButWasntReadedQrCodePerson =
      this.isResponsavelCheckin && !this.hasCheckIn && !wasReadedQrCodePerson;

    return hasAutoCheckinAndReadedQrCodePerson || isResponsibleCheckinButWasntReadedQrCodePerson;
  }

  async handleCheckinResponsibility(parsedBarCode: any): Promise<boolean> {
    const data = await this.userProvider.getDadosInstituicao();
    const idInstituicaoLeitor = data.id;

    return new Promise<boolean>((resolve, reject) => {
      this.instituicao.compareInstituicoes(idInstituicaoLeitor, parsedBarCode.I).subscribe((data) => {
        if (data) {
          this.pessoaCheckin = {
            idPessoa: parsedBarCode.C ? parsedBarCode.C : parsedBarCode,
          };

          resolve(true);
        } else {
          this.showAlert("Instituição inválida", "O QRCode lido não pertence a sua instituição ou filiais");
          reject();
        }
      });
    });
  }

  isBarCodeValid(textBarCode: string, wasReadedQrCodePerson: boolean): boolean {
    return (
      this.idCulto === textBarCode ||
      textBarCode === `Culto-${this.cultoAgenda.agenda.idInstituicao}` ||
      wasReadedQrCodePerson
    );
  }

  presenca() {
    this.cultoProvider
      .salvarPresenca(this.idCulto, this.dataInicio, this.idCultoAgenda, this.pessoaCheckin, false)
      .subscribe(async (data) => {
        let alert = await this.alertCtrl.create({
          cssClass: "alerta-personalizado",
          mode: "ios",
          header: data.title,
          message: data.message,
          buttons: [
            {
              text: this.translate.instant("Fechar"),
              handler: () => {
                this.buscar();
              },
            },
          ],
        });
        alert.present();

        setTimeout(() => {
          alert.dismiss();
        }, 1500);
      });
  }

  private async showAlert(title = "Atenção", message = "Código inválido") {
    const alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: title,
      message: message,
      buttons: ["OK"],
    });
    await alert.present();
  }

  habilitarCheck(multiplosCheckin: boolean) {
    this.multiplosCheckin = !multiplosCheckin ? true : false;
  }
}
